import React, { useState } from "react";
import { Link } from "react-router-dom";
import useSubmitting from "../../hooks/useSubmitting";
import baseUrl from "../../api/baseUrl";
import { setEncryptedTokens } from "../../utils/crypto/cryptoUtils";
import LoginShell from "./LoginShell";
import { EyeOff, EyeOpen } from "./PasswordToggleIcons";
import { inputClass, linkClass, submitClass } from "./loginStyles";

function BranchLogIn() {
  const [formdata, setformdata] = useState({
    email: "",
    password: "",
    error: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, wrap] = useSubmitting();

  const handlechange = (e: any) => {
    setformdata((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onSubmit = async (e: any) => {
    e.preventDefault();
    localStorage.clear();

    try {
      const response = await baseUrl.post(
        "branch/employee/employee-login",
        formdata,
      );
      const martArray = response.data.data.martData || [];
      const d = response.data.data;

      const commonData = [
        { key: "user", value: d.user },
        { key: "token", value: d.token },
        { key: "routeAccess", value: JSON.stringify(d.routeAccess) },
        { key: "permissionDenied", value: JSON.stringify(d.permissionDenied) },
        { key: "marts", value: JSON.stringify(martArray) },
        { key: "email", value: d.email },
        { key: "name", value: d.lastName + " " + d.firstName },
        { key: "currency", value: d.currency || "Rs." },
        { key: "companyId", value: String(d.companyId) || "" },
        { key: "designation", value: d.role || "" },
      ];

      if (martArray.length === 1) {
        setEncryptedTokens([
          ...commonData,
          { key: "selectedMartId", value: String(martArray[0].id) },
          { key: "martName", value: martArray[0].name },
          { key: "address", value: martArray[0].address },
          { key: "phoneNumber", value: martArray[0].phoneNumber },
          { key: "isEmailShown", value: String(martArray[0].email) },
          {
            key: "registrationNumber",
            value: martArray[0].registerNumber || "",
          },
          { key: "logo", value: martArray[0].logo || "" },
          {
            key: "defaultTax",
            value:
              martArray[0].defaultTax != null
                ? String(martArray[0].defaultTax)
                : "",
          },
          {
            key: "advancedDeletion",
            value: String(martArray[0].advancedDeletion || false),
          },
        ]);
        window.location.href = "/dashboard";
      } else if (martArray.length > 1) {
        setEncryptedTokens(commonData);
        window.location.href = "/marts";
      } else {
        alert("No Marts found for this user");
        window.location.reload();
      }
    } catch (error) {
      setformdata((prev) => ({ ...prev, error: true }));
      console.error(error);
    }
  };

  return (
    <LoginShell
      variant="branch"
      title="Sign in"
      subtitle="Use your branch email and password to continue."
    >
      <form onSubmit={wrap(onSubmit)} className="flex w-full flex-col gap-4">
        <div className="flex w-full flex-col gap-[7px]">
          <label htmlFor="branch-email" className="login-label">
            Email
          </label>
          <input
            id="branch-email"
            name="email"
            type="email"
            placeholder="name@company.com"
            className={inputClass("branch")}
            onChange={handlechange}
            value={formdata.email}
            autoComplete="username"
            required
          />
        </div>
        <div className="flex w-full flex-col gap-[7px]">
          <label htmlFor="branch-password" className="login-label">
            Password
          </label>
          <div className="relative w-full">
            <input
              id="branch-password"
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Enter password"
              className={`${inputClass("branch")} pr-11`}
              onChange={handlechange}
              value={formdata.password}
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              className="absolute right-2.5 top-1/2 m-0 inline-flex -translate-y-1/2 items-center justify-center border-0 bg-transparent p-1 text-[#7a8781] hover:bg-transparent hover:text-login-ink"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
              tabIndex={-1}
            >
              {showPassword ? <EyeOff /> : <EyeOpen />}
            </button>
          </div>
        </div>
        <Link
          to="/forgot-password"
          className={`${linkClass("branch")} -mt-1 self-end`}
        >
          Forgot password?
        </Link>
        <button
          type="submit"
          disabled={submitting}
          className={submitClass("branch")}
        >
          {submitting ? "Signing in..." : "Sign in"}
        </button>
        {formdata.error ? (
          <span className="login-error">Invalid credentials</span>
        ) : null}
      </form>
    </LoginShell>
  );
}

export default BranchLogIn;
